import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "min-h-screen bg-white flex flex-col justify-center items-center px-4 py-12",
  style: {"font-family":"'Poppins', sans-serif"}
}
const _hoisted_2 = { class: "w-full max-w-xl bg-white p-8 flex flex-col items-center text-center" }
const _hoisted_3 = { class: "w-full flex flex-col sm:flex-row gap-4 justify-center items-center" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-3xl font-extrabold text-gray-900 tracking-tight mb-2" }, " ¡Acreditación Exitosa! ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-600 mb-8 max-w-sm" }, " Tu credencial ha sido generada correctamente. Podés descargarla a continuación. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.hash)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadCredencial && _ctx.downloadCredencial(...args))),
              href: _ctx.downloadUrl,
              download: "",
              id: "btn-download-credencial",
              class: "w-full sm:w-auto inline-flex justify-center items-center px-8 py-3.5 bg-[#ec1c24] border border-[#ec1c24] text-white hover:bg-white hover:text-[#ec1c24] font-semibold rounded-xl transition duration-200 shadow-md cursor-pointer hover:shadow-lg transform active:scale-95"
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "pi pi-download mr-2 text-lg" }, null, -1),
              _createTextVNode(" Descargar Credencial ", -1)
            ]))], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}